"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BellFilled = function BellFilled(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.73 16.447l-2.147-3.218a2.794 2.794 0 01-.572-1.391v-1.093c-.021-2.739-1.155-4.677-3.058-5.445A2.008 2.008 0 0014 5a2 2 0 00-4 0 1.985 1.985 0 00.048.286c-1.9.76-3.038 2.7-3.059 5.463v1.089a2.794 2.794 0 01-.572 1.391L4.261 16.46a1.781 1.781 0 00-.041 1.787A1.415 1.415 0 005.45 19h3.728a2.991 2.991 0 005.644 0h3.711a1.521 1.521 0 001.247-.753 1.785 1.785 0 00-.05-1.8zM11 5a1 1 0 012 0v.021a5.676 5.676 0 00-1.028-.1 5.576 5.576 0 00-.972.095zm1 15a2.008 2.008 0 01-1.729-1h3.458A2.008 2.008 0 0112 20z",
    fill: "currentColor"
  })));
};

var _default = BellFilled;
exports["default"] = _default;